import React from 'react';
import { observer } from 'mobx-react-lite';

import { Separator } from '../common/Separator';
import { IListViewProps, ListView } from '../views/ListView';
import { ConversationItem } from './ConversationItem';
import type { Conversation } from '@models/Chats/ConversationModel';

interface IConversationListProps
  extends Omit<IListViewProps<Conversation>, 'renderItem'> {
  data: Conversation[];
  onPress(item: Conversation): void;
}

export const ConversationList = observer<IConversationListProps>(
  ({ data, onPress, ...props }) => {
    return (
      <ListView<Conversation>
        keyExtractor={(i) => i.id.toString()}
        data={data}
        renderItem={({ item }) => (
          <ConversationItem item={item} onPress={onPress} />
        )}
        ListHeaderComponent={Separator}
        ItemSeparatorComponent={() => <Separator size="$8" />}
        {...props}
      />
    );
  },
);
